import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import moment from 'moment'

import { FrascoForm } from './components/Frasco';
import { PrimaryRoundedButton } from '../..';

export const MultiFormFrascosAlxoid = ({ formsStatus='checked', name, onFormsChange, setFormValidation, value }) => {

    const [elements, setElements] = useState((typeof value !== 'undefined') ? value.map(val => ({ id: val.id, frasco: val.frasco, concentracion: val.concentracion, volumenAlergeno: val.volumenAlergeno, volumenTotal: val.volumenTotal, validation: true })) : [])

    const handleAddElement = () => {
        if(elements.length < 2){
            let frascoIdentificador = 'A';
            if(elements.length === 1 && elements[0].frasco === 'A'){
                frascoIdentificador = 'B';
            }
            setElements([...elements, { id: moment().unix(), frasco: frascoIdentificador, concentracion: '0', volumenAlergeno: 0.00, volumenTotal: 0.00, validation: false }]);
        }
    }

    const handleRemoveElement = (id) => {
        setElements(elements.filter(element => element.id !== id));
    }

    const handleSetElementData = (data) => {
        setElements(elements.map(element => {
            if(element.id === data.id){
                return data;
            }else{
                return element;
            }
        }));
    }

    useEffect(() => {
        onFormsChange({ target: { name: name, value: elements.map(element => ({
            id: element.id,
            frasco: element.frasco,
            concentracion: element.concentracion,
            volumenAlergeno: element.volumenAlergeno,
            volumenTotal: element.volumenTotal,
        })) } });
        let errorElements = elements.filter(element => (!element.validation));
        setFormValidation(name, (errorElements.length === 0));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [elements])

    return (
        <>
            {elements.map((element, index) => <FrascoForm
                key={element.id}
                element={element}
                removeElement={handleRemoveElement}
                onFormChange={handleSetElementData}
                first={index === 0}
                formStatus={formsStatus}
            />)}
            {(elements.length < 2) &&
            <div className='centrar'>
                <PrimaryRoundedButton
                    icon="Plus"
                    onClick={handleAddElement}
                    type="button"
                />
            </div>
            }
        </>
    )
}

MultiFormFrascosAlxoid.propTypes = {
    formsStatus: PropTypes.oneOf(['checked', 'checking']),
    name: PropTypes.string.isRequired,
    onFormsChange: PropTypes.func.isRequired,
    setFormValidation: PropTypes.func,
    value: PropTypes.array
}